import {useLocation, useNavigate} from "react-router-dom";
import { useDispatch } from "react-redux";
import { paths } from "../../../constants/paths";
import { useLazyGetAccountQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader, setUserData } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useGetAccountApi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [getAccount] = useLazyGetAccountQuery();
  const location = useLocation();

  const get = () => {
    dispatch(setLoader(true));
    getAccount()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setUserData(res?.data));
        if (!res?.data?.registration_completed) {
          navigate("/register-details");
          showToast("Complete your registration please", "error");
        }
        else {
          const publicPaths = [...Object.values(paths.auth), paths.registerDetails];
          if (publicPaths.includes(location?.pathname)) {
            navigate("/");
          }
        }
      })
      .catch((err) => {
        dispatch(setLoader(false));
        if(err?.status === 401) {
          localStorage.removeItem('techsbook_customer_portal_token')
        }
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  return {
    get,
  };
};

export default useGetAccountApi;
